import Honeybadger from 'honeybadger-js'

const config = {
  api_key: window.HONEYBADGER_JS_KEY,
  environment: window.NODE_ENV
}

export const honeybadger = Honeybadger.configure(config)
